import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '../../cn';

/**
 * PageContainer — the ONLY legal page outer frame (#1392 D1).
 *
 * Owns the page-level padding (horizontal + top/bottom) and the vertical
 * rhythm that used to be split between `AppLayout` (`px-4 pt-4 pb-16`) and each
 * page's own `space-y-*` / `container mx-auto p-4` wrapper. Every routed page
 * renders inside exactly one of these so the whole app shares one padding and
 * one rhythm — no per-page max-width caps (parity-first: content spans the full
 * content column).
 *
 * Kept deliberately dumb: it forwards `className` and any standard div
 * attributes (e.g. `data-testid`) so pages whose old wrapper carried those can
 * migrate without losing them.
 */
interface PageContainerProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function PageContainer({ children, className, ...rest }: PageContainerProps) {
  return (
    <div className={cn('px-4 pt-4 pb-16 space-y-6', className)} {...rest}>
      {children}
    </div>
  );
}
